module.exports = __webpack_public_path__ + "img/img6_1.4fb13911.jpeg";